import { Component, OnInit } from '@angular/core';
import {FormGroup, FormBuilder, Validators, AbstractControl} from '@angular/forms';
import { AppService } from 'src/app/app.service';
import { Category ,Product} from '../../../app.models';
import { ActivatedRoute } from '@angular/router';
import {AddProductyService} from '../add-product/add-product.service';
import {CategoryService} from "../categories/categories.service";
import {Observable} from "rxjs";
import {NgxSpinnerService} from "ngx-spinner";
import {HttpClient} from "@angular/common/http";
import {ApiUrl} from "../../../pages/cashier/shared/models/apiurl.models";

@Component({
  selector: 'app-add-product',
  templateUrl: './add-product.component.html',
  styleUrls: ['./add-product.component.scss'],
  providers: [ AddProductyService, ApiUrl ]
})
export class AddProductComponent implements OnInit {

  public formAddProduct: FormGroup;
  public colors = [];
 // public sizes = [];
  public selectedColors:string;
  //public selectedSize:string;
  public categories: Category[];
  selectedMainCategory: any;
  private sub: any;
  public id:any;

  public product:Product;

  constructor(public appService:AppService,
              public formBuilder: FormBuilder,
              private activatedRoute: ActivatedRoute,
              private httpClient: HttpClient,
              public addProductyService:AddProductyService,
              private apiUrl: ApiUrl,
              private spinner: NgxSpinnerService
            ) { }

  ngOnInit(): void {
    this.formAddProduct = this.formBuilder.group({
      id: null,
      name: [null, Validators.compose([Validators.required, Validators.minLength(4)])],
      diameter : null,
      description: null,
      supplierPrice: [null, Validators.required ],
      clientPrice:[null, Validators.required ],
      availibilityCount:[null, Validators.required ],
      lumen: null,
      height : null,
      lighting: null,
      opacityLevel: null,
      ledType: null,
      ledPower: null,
      illuminationAngles : null,
      width: null,
      length: null,
      lightHue: null,
      voltage: null,
      depth: null,
      bore: null,
      cri: null,
      barCode: null,
      generatedBarcode: null,
      warranty: null,
      workHours: null,
      deviceStatus: null,
      createTime: null,
      updateTime: null,
      discount: null,
      ratingsCount: null,
      ratingsValue: null,
      weight: null,
      column: null,
      row: null,
      layer: null,
      images: null, //v
      color: null, //v
     // size :null,
      mainCategory: null, //v
    }); 
    this.getCategories();
    this.getColor();
    // this.getSize();
    this.sub = this.activatedRoute.params.subscribe(params => {
      if(params['id']){
        this.id = params['id'];
        this.getProductById();
      }
    });
  }

  public getCategories(){   
    this.appService.getCategories().subscribe((data:any) => {
      this.categories = data.object_list;
      // this.categories.shift();
    }); 
  }

  public getColor(){
    this.appService.getColor().subscribe((data:any) => {
      this.colors = data.results;
      // this.colors.shift();
    });
  }

 //public getSize(){
   // this.appService.getSize().subscribe((data:any) => {
     // this.sizes = data.results;
      // this.sizes.shift();
    //});
 // }

  async getBase64ImageFromUrl(imageUrl) {
    var res = await fetch(imageUrl);
    var blob = await res.blob();

    return new Promise((resolve, reject) => {
      var reader  = new FileReader();
      reader.addEventListener("load", function () {
        resolve(reader.result);
      }, false);

      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(blob);
    })
  }

  public getProductById(){
    this.appService.getProductById(this.id).subscribe((data:any)=>{
      data.color = data.color.map(res=>res.id)
      this.selectedMainCategory = data.mainCategory;
      this.formAddProduct.patchValue(data);
      const images: any[] = [];
      data.images.forEach(item=>{
        let image = {
          link: item.medium,
          preview: item.medium
        }
        images.push(image);
      })
      this.formAddProduct.controls.images.setValue(images);
    });

    //this.appService.getProductById(this.id).subscribe((data:any)=>{
     // this.form.patchValue(data);
     // this.selectedColors = data.color;
     // const images: any[] = [];
     // data.images.forEach(item=>{
      //  let image = {
       //   link: item.medium,
        //  preview: item.medium
       // }
        //images.push(image);
      //})
      //this.form.controls.images.setValue(images);
    //});
  }

  async ImageProcessing(imageList):Promise<any>{
    let promiseArr = [];
    let images = []
    const imageArr = imageList.map(image => {
      if(image.link) {
        const asyncFunc = this.getBase64ImageFromUrl(image.link)
        promiseArr.push(asyncFunc)
      }else{
        if(image.preview){
          images.push(image.preview)
        }else{
          images.push(image.small)
        }
      }
    })
    const promiseFuncs = await Promise.all(promiseArr);
    images.push(...promiseFuncs);
    return images;
  }

  public onSubmit(){
    this.spinner.show();
    if(!this.formAddProduct.value.id) return;
    let imageList = []
    this.ImageProcessing(this.formAddProduct.value.images).then(res=>{
      const processedImage = res.map((res) => {
            return {
              title: 11,
              small: res,
              medium: res,
              big: res
            }
          })
      this.formAddProduct.value.mainCategory = this.categories.find(cate=>cate.id == this.selectedMainCategory.id).id;
      this.formAddProduct.value.images = []
      this.formAddProduct.value.images.push(...processedImage);
      this.addProductyService.updateProduct(this.formAddProduct.value).subscribe(res=>{

      })
    })
    // const imageArr = this.formAddProduct.value.images.map(image =>{
    //   if(image.link){
    //     this.getBase64ImageFromUrl(image.link).then(res =>{
    //       imageList.push(res)
    //     })
    //   }else {
    //     if(image.preview){
    //       imageList.push(image.preview)
    //     }else{
    //       imageList.push(image.small)
    //     }
    //
    //   }
    // })
    // setTimeout(()=>{
    //   this.formAddProduct.value.images = []
    //   const processedImage = imageList.map((res) => {
    //         return {
    //           title: 11,
    //           small: res,
    //           medium: res,
    //           big: res
    //         }
    //       }
    //   )
    //   this.formAddProduct.value.mainCategory = this.categories.find(cate=>cate.id == this.selectedMainCategory.id).id;
    //   this.formAddProduct.value.images.push(...processedImage);
    //   console.log(this.formAddProduct.value)
    //   // this.addProductyService.updateProduct(this.formAddProduct.value).subscribe(res=>{
      //   console.log(res)
      // })
    // },350)

  }

 // public onSizeSelectionChange(event: any) {
 //   if(event){
 //     this.selectedSize = event.value.join();
//    }
 // }

  public onColorSelectionChange(event: any){
    if(event.value){
      this.selectedColors = event.value.join();
    } 
  }  

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
  saveProduct(){
    const formForUi = this.formAddProduct.value;
    let newProduct = {}
    newProduct['id'] = formForUi.id || null
    newProduct['name'] = formForUi.name;
    newProduct['diameter'] = formForUi.diameter;
    newProduct['description'] = formForUi.description;
    newProduct['supplierPrice'] = formForUi.supplierPrice;
    newProduct['clientPrice'] = formForUi.clientPrice;
    newProduct['availibilityCount'] = formForUi.availibilityCount;
    newProduct['lumen'] = formForUi.lumen;
    newProduct['height'] = formForUi.height;
    newProduct['lighting'] = formForUi.lighting;
    newProduct['opacityLevel'] = formForUi.opacityLevel;
    newProduct['ledType'] = formForUi.ledType;
    newProduct['ledPower'] = formForUi.ledPower;
    newProduct['illuminationAngles'] = formForUi.illuminationAngles;
    newProduct['width'] = formForUi.width;
    newProduct['length'] = formForUi.length;
    newProduct['voltage'] = formForUi.voltage;
    newProduct['depth'] = formForUi.depth;
    newProduct['bore'] = formForUi.bore;
    newProduct['cri'] = formForUi.cri;
    newProduct['barCode'] = formForUi.barCode;
    newProduct['generatedBarcode'] = formForUi.generatedBarcode;
    newProduct['warranty'] = formForUi.warranty;
    newProduct['workHours'] = formForUi.workHours;
    newProduct['deviceStatus'] = formForUi.deviceStatus;
    newProduct['createTime'] = formForUi.createTime;
    newProduct['updateTime'] = formForUi.updateTime;
    newProduct['discount'] = formForUi.discount;
    newProduct['ratingsCount'] = formForUi.ratingsCount;
    newProduct['ratingsValue'] = formForUi.ratingsValue;
    newProduct['weight'] = formForUi.weight;
    newProduct['images'] = formForUi.images;
    newProduct['color'] = formForUi.color;
    newProduct['row'] = formForUi.row;
    newProduct['column'] = formForUi.column;
    newProduct['layer'] = formForUi.layer;
    if(!(this.categories.find(cate=>cate.id == this.selectedMainCategory?.id)?.id)){
      alert("בחר קטגוריה")
      return;
    }
    newProduct['mainCategory'] = this.categories.find(cate=>cate.id == this.selectedMainCategory.id);
   // newProduct['size'] = formForUi.size;
    newProduct['name'] = formForUi.name;

    if(newProduct['id'] == null){
      this.addProductyService.addProduct(newProduct).subscribe(res=>{

      });
    }

  }
  public drawerCreateBtnFlg: number = 0;
  productFormFlg = false;
  submitted = false;
  isDrawerExist(): void {
    const formV=this.formAddProduct.value;
    if(formV.row == '' || formV.column == '' || formV.layer == ''){
      this.drawerCreateBtnFlg=0;
      this.productFormFlg = false;
      return;
    }
    this.httpClient.get(this.apiUrl.getDrawer() +'?column='+formV.column + '&row='+formV.row + '&layer='+formV.layer).subscribe((res:any)=>{
      this.drawerCreateBtnFlg=-1;
      if(res.length>0){
        this.productFormFlg=true;
        this.drawerCreateBtnFlg=1;
      }else{
        this.productFormFlg=false;
      }

    });
  }
  createDrawerObject(){
    return {
      warehouse: 1,
      row: this.formAddProduct.value.row,
      column: this.formAddProduct.value.column,
      layer: this.formAddProduct.value.layer,
      capacity: null
    }
  }
  generateBarcodeForUnBarcodeProducts(): string {
    // Get the current date and time
    const now = new Date();

    // Format the current datetime
    const formattedDatetime = now.toISOString().replace(/[^0-9]/g, '');

    // Generate a random 5-digit code
    const generatedCode = Array.from({ length: 5 }, () => Math.floor(Math.random() * 10)).join('');

    // Construct the final number
    const finalNumber = `938${formattedDatetime.substring(0, 17)}${generatedCode}`;

    return finalNumber;
  }

  get barcodeDisabled(){
    return this.formAddProduct.controls.generatedBarcode.value != '' && this.formAddProduct.controls.generatedBarcode.value != null;
  }

  get f(): { [key: string]: AbstractControl } {
    return this.formAddProduct.controls;
  }
  generateBarcode($event) {
    $event.preventDefault();
    const generatedBarcode = this.generateBarcodeForUnBarcodeProducts();
    this.formAddProduct.patchValue({'barCode':generatedBarcode});
    this.formAddProduct.patchValue({'generatedBarcode':generatedBarcode});
    console.log(this.formAddProduct)
  }

  addDrawerBtn() {
    this.httpClient.post(this.apiUrl.getDrawer(),this.createDrawerObject()).subscribe(res=>{
      this.drawerCreateBtnFlg = 1;
      this.productFormFlg=true;
    })
  }
  get getDrawerClass(): any{
    if(this.drawerCreateBtnFlg == -1)
      return 'not-drawer-exist';
    if(this.drawerCreateBtnFlg == 1)
      return 'drawer-exist'
    return '';
  };
}
